import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';

function Layout({ children }) {
    return (
        <>
            <div>
                <Link to="/">
                    <Navbar />
                </Link>
            </div>
            <div className="App">
                <div className="main">
                    <div className="container">{children}</div>
                </div>

                <div className="footer">&copy;2022 Learn with Sumit</div>
            </div>
        </>
    );
}

export default Layout;
